import { Message, Notification, MessageBox } from 'element-ui';
import store from '@/store';
import i18n from '@/lang/index';

const currentMsg = new Map();
function SettingObj(type, msg) {
	return {
		type: { e: 'error', s: 'success' }[type] || type,
		message: msg,
		onClose() {
			currentMsg.delete(msg);
		},
	};
}
export function ALERT(title, msg) {
	MessageBox.alert(msg, title, {
		confirmButtonText: i18n.t('label.ok'),
	});
}
export function MESSAGE(type, msg) {
	if (!store.state.messageBox_ready) return false;
	if (currentMsg.has(msg)) return false;
	currentMsg.set(msg);

	let delay = currentMsg.length > 1 ? 100 : 0;
	setTimeout(() => {
		Message({
			...new SettingObj(type, msg),
			showClose: true,
		});
	}, delay);
}
export function NOTIFICATION(type, msg) {
	if (!store.state.messageBox_ready) return false;
	if (currentMsg.has(msg)) return false;
	currentMsg.set(msg);

	let delay = currentMsg.length > 1 ? 100 : 0;
	setTimeout(() => {
		Notification({
			...new SettingObj(type, msg),
			position: 'bottom-left',
		});
	}, delay);
}
export function CONFIRM(params) {
	store.state.confirm.show = true;
	const {
		type = 'confirm',
		title, text,
		submit, close,
		label_submit, label_cancel
	} = params;
	store.state.confirm.type = type;
	store.state.confirm.title = title;
	store.state.confirm.text = text;
	store.state.confirm.label_submit = label_submit || {
		confirm: i18n.t('label.ok'),
		delete: i18n.t('label.delete'),
	}[type];
	store.state.confirm.label_cancel = label_cancel || i18n.t('label.cancel');

	store.state.confirm.submit = submit ? () => {
		if (params.submit) params.submit();
		store.state.confirm.show = false;
	} : undefined;
	store.state.confirm.close = close ? () => {
		if (params.close) params.close();
		store.state.confirm.show = false;
	} : undefined;
}
